import React from "react";

import IconBase, { IconBaseProps } from "./IconBase";

/**
 * Vitamin — 20×20 lab group icon (Figma 834:61).
 * Pill/capsule motif, single layer 15.4167×15.4167, insets
 * top/left 8.33% and right/bottom 14.58%.
 */
const IconVitamin: React.FC<IconBaseProps> = ({
  size = 24,
  color = "currentColor",
  className = "",
  ...props
}) => {
  const iconSize =
    typeof size === "number" ? size : parseInt(size as string, 10) || 24;
  return (
    <IconBase
      size={iconSize}
      color={color}
      className={className}
      viewBox="0 0 20 20"
      {...props}
    >
      <g transform="translate(1.666 1.666)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.84867 0.876704L5.97196 0L5.42904 0.542904L6.24342 1.35727L1.35726 6.24342L0.542904 5.42904L0 5.97196L0.876704 6.84867C2.34872 8.32067 4.40733 8.97346 6.40392 8.68208C6.46625 8.40575 6.54517 8.13142 6.64092 7.8605C5.80154 8.03663 4.94092 8.01971 4.12204 7.82187L7.82187 4.12204C8.09429 5.24975 8.02367 6.45667 7.57821 7.57821L7.57575 7.58438C7.55754 7.63004 7.53871 7.67554 7.51929 7.72092C7.35792 8.17533 7.40388 8.05546 7.40388 8.05546C7.40388 8.05546 7.39788 8.07229 7.37271 8.14192L5 10.5146L8.75996 14.2745C10.2828 15.7974 12.7518 15.7974 14.2745 14.2745C15.7974 12.7518 15.7974 10.2828 14.2745 8.75996L10.5146 5L8.58246 6.93213C9.08258 4.77633 8.45096 2.479 6.84867 0.876704ZM3.30138 7.55675L7.55696 3.30117C7.358 2.81408 7.09071 2.35151 6.75792 1.92858L1.9288 6.75771C2.35173 7.0905 2.81433 7.35779 3.30138 7.55675ZM7.79733 10.1248L9.99329 12.3619C10.373 12.7488 10.8047 12.9336 11.2128 12.9441C11.6179 12.9545 12.0398 12.7946 12.411 12.4165L13.0057 13.0002C12.4875 13.5282 11.8479 13.794 11.1915 13.7771C10.5381 13.7603 9.90821 13.4649 9.39858 12.9457L7.20267 10.7085L7.79733 10.1248Z"
        />
      </g>
    </IconBase>
  );
};

export default IconVitamin;
